<label
  class="advanced-datepicker"
  [attr.for]="undefined"
  [class.invalid]="showError"
  [class.viewonly]="viewOnly"
  [class.focused]="isFocused"
  caiTooltip
  [tooltip]="input.value"
  [detectOverflow]="true"
  [target]="input"
>
  @if (!viewOnly) {
    <span class="icon">
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.41668 0.833252C7.41668 0.419038 7.08089 0.083252 6.66668 0.083252C6.25246 0.083252 5.91668 0.419038 5.91668 0.833252V1.78614C5.89207 1.78901 5.86779 1.79212 5.84377 1.79547C3.7414 2.08874 2.08883 3.74131 1.79556 5.84368C1.7499 6.17098 1.74994 6.54718 1.75 7.13857L1.75001 7.2058V11.0999L1.75001 11.1329C1.75 12.2251 1.75 13.0906 1.807 13.7882C1.86528 14.5016 1.98689 15.1052 2.26773 15.6564C2.72313 16.5501 3.44978 17.2768 4.34355 17.7322C4.89473 18.013 5.49835 18.1346 6.21174 18.1929C6.90935 18.2499 7.77482 18.2499 8.86692 18.2499H8.86699H8.90001H11.1H11.133H11.1331C12.2252 18.2499 13.0907 18.2499 13.7883 18.1929C14.5017 18.1346 15.1053 18.013 15.6565 17.7322C16.5502 17.2768 17.2769 16.5501 17.7323 15.6564C18.0131 15.1052 18.1347 14.5016 18.193 13.7882C18.25 13.0906 18.25 12.225 18.25 11.1329V11.0999V8.89992V8.86695C18.25 7.77479 18.25 6.90928 18.193 6.21165C18.1347 5.49826 18.0131 4.89464 17.7323 4.34346C17.2769 3.44969 16.5502 2.72304 15.6565 2.26764C15.1829 2.02636 14.6707 1.90261 14.0833 1.83557V0.833252C14.0833 0.419038 13.7476 0.083252 13.3333 0.083252C12.9191 0.083252 12.5833 0.419038 12.5833 0.833252V1.75664C12.1498 1.74991 11.6687 1.74992 11.133 1.74992L11.1 1.74992H7.41668V0.833252ZM12.5833 3.33325V3.25682C12.1593 3.25007 11.6715 3.24992 11.1 3.24992H7.41668V3.33325C7.41668 3.74747 7.08089 4.08325 6.66668 4.08325C6.25246 4.08325 5.91668 3.74747 5.91668 3.33325V3.30267C4.54258 3.55292 3.47554 4.65754 3.28118 6.05091C3.25182 6.26134 3.25001 6.52486 3.25001 7.2058V11.0999C3.25001 12.2324 3.25059 13.0367 3.30202 13.666C3.35272 14.2867 3.4491 14.6709 3.60424 14.9754C3.91583 15.5869 4.41301 16.0841 5.02454 16.3957C5.32901 16.5508 5.71326 16.6472 6.33389 16.6979C6.96327 16.7493 7.76753 16.7499 8.90001 16.7499H11.1C12.2325 16.7499 13.0367 16.7493 13.6661 16.6979C14.2868 16.6472 14.671 16.5508 14.9755 16.3957C15.587 16.0841 16.0842 15.5869 16.3958 14.9754C16.5509 14.6709 16.6473 14.2867 16.698 13.666C16.7494 13.0367 16.75 12.2324 16.75 11.0999V8.89992C16.75 7.76744 16.7494 6.96318 16.698 6.3338C16.6473 5.71317 16.5509 5.32892 16.3958 5.02445C16.0842 4.41292 15.587 3.91574 14.9755 3.60415C14.7458 3.48714 14.4708 3.40355 14.0832 3.34778C14.0755 3.75529 13.7427 4.08325 13.3333 4.08325C12.9191 4.08325 12.5833 3.74747 12.5833 3.33325ZM5.83335 5.91659C5.41914 5.91659 5.08335 6.25237 5.08335 6.66659C5.08335 7.0808 5.41914 7.41659 5.83335 7.41659H14.1667C14.5809 7.41659 14.9167 7.0808 14.9167 6.66659C14.9167 6.25237 14.5809 5.91659 14.1667 5.91659H5.83335ZM7.50002 9.99992C7.50002 10.4602 7.12692 10.8333 6.66669 10.8333C6.20645 10.8333 5.83335 10.4602 5.83335 9.99992C5.83335 9.53968 6.20645 9.16659 6.66669 9.16659C7.12692 9.16659 7.50002 9.53968 7.50002 9.99992ZM6.66669 14.1666C7.12692 14.1666 7.50002 13.7935 7.50002 13.3333C7.50002 12.873 7.12692 12.4999 6.66669 12.4999C6.20645 12.4999 5.83335 12.873 5.83335 13.3333C5.83335 13.7935 6.20645 14.1666 6.66669 14.1666ZM10.8334 13.3333C10.8334 13.7935 10.4603 14.1666 10 14.1666C9.53978 14.1666 9.16669 13.7935 9.16669 13.3333C9.16669 12.873 9.53978 12.4999 10 12.4999C10.4603 12.4999 10.8334 12.873 10.8334 13.3333ZM13.3334 14.1666C13.7936 14.1666 14.1667 13.7935 14.1667 13.3333C14.1667 12.873 13.7936 12.4999 13.3334 12.4999C12.8731 12.4999 12.5 12.873 12.5 13.3333C12.5 13.7935 12.8731 14.1666 13.3334 14.1666ZM10.8334 9.99992C10.8334 10.4602 10.4603 10.8333 10 10.8333C9.53978 10.8333 9.16669 10.4602 9.16669 9.99992C9.16669 9.53968 9.53978 9.16659 10 9.16659C10.4603 9.16659 10.8334 9.53968 10.8334 9.99992ZM13.3334 10.8333C13.7936 10.8333 14.1667 10.4602 14.1667 9.99992C14.1667 9.53968 13.7936 9.16659 13.3334 9.16659C12.8731 9.16659 12.5 9.53968 12.5 9.99992C12.5 10.4602 12.8731 10.8333 13.3334 10.8333Z"
          fill="#B6B6B6"
        />
      </svg>
    </span>
  }
  <input
    #input
    [placeholder]="label"
    [value]="value | date: displayFormat"
    (focus)="onTouched()"
    (keyup.enter)="open(picker)"
    (keyup.Space)="open(picker)"
    (click)="open(picker)"
    [disabled]="viewOnly ? true : null"
    [class.float-label]="floatLabel"
    [class.label-center]="labelCenter"
    readonly
  />
  <span class="label">{{ label }}</span>
</label>

<input
  class="invisible position-absolute"
  style="top: 20px"
  readonly
  matInput
  [matDatepicker]="dp"
  [placeholder]="label"
  [min]="minDate"
  [max]="maxDate"
  [(ngModel)]="value"
/>
<mat-datepicker
  #dp
  disabled="false"
  #picker="matDatepicker"
  (closed)="close($event)"
></mat-datepicker>
